import React from 'react';
import './styles/Footer.css'; 
import logo from "../assets/logo.jpg"; 
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Brand/Info */}
        <div className="logo">
          <img src={logo} alt="Airflex Logo" className="logo-imgfooter" />
          <p>At Airflex RSA, your car is not just a car — it’s a statement.
          </p>
        </div>

        {/* Navigation Links */}
        <div className="footer-links">
          <h3 style={{paddingLeft:"20px"}}>Quick Links</h3>
          <ul>
            <li>
      <a style={{color:'blue'}} href="/AIRFLEX.apk" download>
        Download Airflex Suspension App
      </a>
    </li>
          </ul>
        </div>

        {/* Contact / Social */}
        <div className="footer-contact">
          <h3>Connect with Us</h3>
          <p className="flex items-center gap-2">
        <MdEmail className="text-white-600 w-6 h-6" />
        <span> airflexrsa@gmail.com </span>
      </p>
      <p className="flex items-center gap-2">
        <MdPhone className="text-white--600 w-6 h-6" />
        <span> 082 747 2013 / 067 646 6696</span>
      </p>
      <p className="flex items-center gap-2">
        <MdLocationOn className="text-white-600 w-10 h-10" />
        <span>House No. 1687, Thorn Street, Shayandima, Thohoyandou, Limpopo.</span>
      </p>
          <div className="footer-social">
            <a href="#">Facebook</a>
            <a href="#">Instagram</a>
            <a href="#">Twitter</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
       <span> © {new Date().getFullYear()} Airflex. All rights reserved.</span>
        <span>Developer:P3.dev</span>
      </div>
    </footer>
  );
};

export default Footer;
